import "bootstrap";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/pt-br";
import "element-ui/lib/theme-chalk/index.css";
import VueMask from "v-mask";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import Vue2Filters from "vue2-filters";
import App from "./App.vue";
import "./assets/scss/index.scss";
import "./registerServiceWorker";
import router from "./routes";
import ApiService from "./services/api.services";
import store from "./store";

Vue.component("downloadExcel", JsonExcel);
Vue.use(Vue2Filters);

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.use(VueMask);

ApiService.init(process.env.VUE_APP_API_URL);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
